import DescriptionPaneSelectEditor from './DescriptionPaneSelectEditor';

export default DescriptionPaneSelectEditor;
export { DescriptionPaneSelectEditor };
